import { ref } from 'vue'

export const showUnsavedDialog = ref(false)
export const dialogResolve = ref<((value: boolean) => void) | null>(null)

export function confirmLeave(): Promise<boolean> {
  showUnsavedDialog.value = true
  return new Promise((resolve) => {
    dialogResolve.value = resolve
  })
}

export function proceedLeave() {
  showUnsavedDialog.value = false
  if (dialogResolve.value) {
    dialogResolve.value(true)
    dialogResolve.value = null
  }
}

export function cancelLeave() {
  showUnsavedDialog.value = false
  if (dialogResolve.value) {
    dialogResolve.value(false)
    dialogResolve.value = null
  }
}
